    import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ClipLoader, HashLoader } from 'react-spinners'; // HashLoader looks great for admin panels

const GlobalLoader = () => {
  // Access the loading state from your Redux store
  const { isLoading } = useSelector((state) => state.loader);
    const {t} = useTranslation()
  if (!isLoading) return null;

return (
    <div style={styles.overlay}>
      <div style={styles.container}>
        {/* Zomato Red: #E23744 */}
        <ClipLoader 
          color="#F0C615" 
          size={60} 
          speedMultiplier={0.5} 
          width={8} // Thickness of the ring
        />
        {/* <h3 style={styles.text}>{t('common.pleaseWait')}</h3> */}
        <p style={styles.subText}>{t('common.pleaseWait')}</p>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh',
    // Glassmorphism effect: light background with blur
    backgroundColor: 'rgba(255, 255, 255, 0.7)', 
    backdropFilter: 'blur(1.5px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 99999, // Stays above everything
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
  },
  text: {
    marginTop: '20px',
    fontSize: '18px',
    fontWeight: '600',
    color: '#1c1c1c',
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
  },
  subText: {
    fontSize: '14px',
    color: '#000000',
    marginTop: '4px',
  }
};

export default GlobalLoader;